import React from 'react';

import { Link } from 'react-router-dom';

import { t } from 'i18next';

import {
  ListItem,
  ListItemButton,
  ListItemText,
} from '@datanomik/commons-ui';

type Props = {
  label: string;
  to?: string;
  action?: string;
  isSelected: boolean;
  inPopover?: boolean;
  onAction?: (action: string) => void;
};

const SidebarSubItem = ({ label, to, action, isSelected, inPopover, onAction }: Props) => {
  const handleActionClick = () => {
    if (action && onAction) onAction(action);
  };

  if (inPopover) {
    const buttonSx = {
      py: 0.75,
      px: 1.5,
      borderRadius: '8px',
      borderLeft: 'none !important',
      backgroundColor: isSelected ? 'primary.lighter' : 'transparent',
      '&:hover': {
        backgroundColor: isSelected ? 'primary.lighter' : 'neutral.100',
      },
    };

    const textProps = {
      fontSize: '13.5px',
      fontWeight: isSelected ? 600 : 400,
      color: isSelected ? 'primary.main' : 'neutral.700',
    };

    return (
      <ListItem sx={{ py: 0.25, px: 0 }}>
        {action ? (
          <ListItemButton onClick={handleActionClick} sx={buttonSx}>
            <ListItemText primary={t(label)} primaryTypographyProps={textProps} />
          </ListItemButton>
        ) : (
          <ListItemButton component={Link} to={to!} sx={buttonSx}>
            <ListItemText primary={t(label)} primaryTypographyProps={textProps} />
          </ListItemButton>
        )}
      </ListItem>
    );
  }

  return (
    <ListItem sx={{ py: 0 }}>
      {action ? (
        <ListItemButton
          onClick={handleActionClick}
          sx={{
            py: 0.5,
            pl: 6.5,
            minHeight: 32,
            borderLeft: 'none !important',
            '&:hover': { backgroundColor: 'action.hover' },
          }}
        >
          <ListItemText
            primary={t(label)}
            primaryTypographyProps={{ fontSize: '13px', fontWeight: 400, color: 'text.primary' }}
          />
        </ListItemButton>
      ) : (
        <ListItemButton
          component={Link}
          to={to!}
          sx={{
            py: 0.5,
            pl: 6.5,
            minHeight: 32,
            borderLeft: 'none !important',
            backgroundColor: isSelected ? 'action.hover' : 'transparent',
            '&:hover': { backgroundColor: 'action.hover' },
          }}
        >
          <ListItemText
            primary={t(label)}
            primaryTypographyProps={{
              fontSize: '13px',
              fontWeight: isSelected ? 600 : 400,
              color: isSelected ? 'primary.main' : 'text.primary',
            }}
          />
        </ListItemButton>
      )}
    </ListItem>
  );
};

export default SidebarSubItem;
